// 获取所有的swiper-slide元素
var slideElements = document.querySelectorAll('.activitySwiper .swiper-slide');
// 获取swiper-slide的数量
var slideCount = slideElements.length;

var activitySwiper = new Swiper(".activitySwiper", {
  slidesPerView: isMobile() ? 1.3 : slideCount,
  spaceBetween: isMobile() ? 12 : 24,
});